import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import {
  clone
} from 'lodash'

import { bemClasses } from '../../../utils/bem'

import './styles.scss'

class DropdownOption extends Component {
  ALLOWED_MODIFIERS = [
    'green', 'blue', 'red', 'orange', 'yellow'
  ]

  componentClassNames = () => {
    let modifiers = clone(this.props)
    modifiers[this.props.color] = true

    return bemClasses('dropdown__option', this.ALLOWED_MODIFIERS, modifiers)
  }

  onClick = () => {
    this.props.onClick(this.props.object)
  }

  renderLink = () => {
    return (
      <a
        href={this.props.href}
        className={this.componentClassNames()}>
        { this.props.text }
      </a>
    )
  }

  renderOnClick = () => {
    return (
      <div
        className={this.componentClassNames()}
        onClick={this.onClick}>
        { this.props.text }
      </div>
    )
  }

  renderNavLink = () => {
    let path = this.props.to

    if (typeof path === 'function') {
      path = path(this.props.object)
    }

    return (
      <NavLink
        to={path}
        exact
        className={this.componentClassNames()}>
        { this.props.text }
      </NavLink>
    )
  }

  renderText = () => {
    return (
      <div className={this.componentClassNames()}>
        { this.props.text }
      </div>
    )
  }

  render = () => {
    if (this.props.href) { return this.renderLink() }
    if (this.props.onClick) { return this.renderOnClick() }
    if (this.props.to) { return this.renderNavLink() }
    return this.renderText()
  }
}

export default DropdownOption
